import React, { FC, useState } from 'react'
import cx from 'classnames'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useFetchProjects, useDuplicateProject, useDeleteProject } from 'services/project'
import { ProjectsTable } from './ProjectsTable/ProjectsTable'
import { Heading } from 'components/Heading'
import { Stack } from 'components/Stack'
import { ProjectCard } from 'components/ProjectCard'
import { usePersistedState } from 'hooks/usePersistedState'
import { Icon } from 'components/Icon'
import { Pagination } from './Pagination'
import { SearchBar } from './SearchBar'
import styles from './Projects.module.scss'
import { Project, ProjectTableFilters } from 'models/project'
import { Flex } from 'components/Flex'
import { Spinner } from 'components/Spinner'
import { Text } from 'components/Text'
const DEFAULT_FILTERS: ProjectTableFilters = {
  offset: 0,
  limit: 10,
  sortBy: 'name_asc',
  q: '',
}
export const Projects: FC = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [isTableView, setTableView] = usePersistedState('isTableView', true)
  const [filters, setFilters] = useState(DEFAULT_FILTERS)
  const { totalItems, projects, status } = useFetchProjects(filters)
  const [duplicateProject] = useDuplicateProject()
  const [deleteProject] = useDeleteProject()
  const onDuplicateProject = (id: string) => {
    duplicateProject(id, {
      onSuccess: (project: Project) => {
        navigate(`/projects/${project.id}`)
      },
    })
  }

  //const onDeleteProject = (id: string) => deleteProject(id)

  function onDeleteDialog(id: string) {
    var popup = null;
    popup = document.getElementById("popupElm");

    try {
      popup!.style.display = "block";
      var inputOculto = document.getElementById("idProyecto")?.firstChild;
      inputOculto!.nodeValue = id;
    }
    catch (error) {
    }
  }

  function confirmDelete() {
    hiddenDiv();
    var idProyecto = document.getElementById("idProyecto")?.firstChild!.nodeValue;
    deleteProject(idProyecto!);
  }

  function hiddenDiv() {
    var popup = null;
    popup = document.getElementById("popupElm");
    popup!.style.display = "none";
  }

  return (
    <div className={styles.projects}>
      <div id="popupElm" className={styles.dialogOverlay}>
        <div className={cx(styles.dialogContent)}>
          <Heading size="secondary">{t('ondeletedialog.title')}</Heading>
          <Text>{t('ondeletedialog.desc')}</Text>
          <br></br>
          <button className={styles.buttonCancelar} onClick={hiddenDiv}>Cancelar</button>
          <br></br><br></br>
          <button className={styles.buttonEliminar} onClick={confirmDelete}>Eliminar</button>
          <div id="idProyecto" className={styles.hideButton}>Hidden</div>
        </div>
      </div>
      <Stack space="large">
        <Flex justify="between" align="center">
          <Heading>{t('project.table.heading')}</Heading>
          <Flex>
            <button
              aria-label={t('project.table.viewToggler.tableView')}
              className={cx({ [styles.switchButton]: true, [styles.isActive]: isTableView })}
              onClick={() => setTableView(true)}
            >
              <Icon name="menu-line" size="xl" />
            </button>
            <button
              aria-label={t('project.table.viewToggler.cardView')}
              className={cx({ [styles.switchButton]: true, [styles.isActive]: !isTableView })}
              onClick={() => setTableView(false)}
            >
              <Icon name="function-line" size="xl" />
            </button>
          </Flex>
        </Flex>
        {status === 'loading' && (
          <Flex justify="center" align="center">
            <Spinner />
          </Flex>
        )}
        {isTableView ? (
          <ProjectsTable
            projects={projects}
            totalItems={totalItems}
            filters={filters}
            setFilters={setFilters}
            deleteItem={onDeleteDialog}
            duplicateItem={onDuplicateProject}
          />
        ) : (
            <Stack space="medium" data-testid="projects-list">
              <Pagination
                totalItems={totalItems}
                offset={filters.offset}
                limit={filters.limit}
                setFilters={(filter) => setFilters({ ...filters, ...filter })}
              />
              <SearchBar q={filters.q} setFilters={(q) => setFilters({ ...filters, q })} />
              <div className={styles.projectsCards}>
                {projects.map((project) => (
                  <ProjectCard project={project} key={project.id} />
                ))}
              </div>
            </Stack>
          )}
      </Stack>
    </div>
  )
}
Projects.displayName = 'Projects'